import {onLCP, onINP, onCLS} from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: { name: string; value: number }) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry);
    onLCP(onPerfEntry);
    onINP(onPerfEntry);
  }
};

export default reportWebVitals;